class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.menu = this.querySelector('ul');
    if(!this.menu) {
      throw new Error('No valid menu found.');
    }
    this.caret = this.querySelector('.caret-down');
    this.isOpen = false;
    this.querySelector('label').addEventListener('click', this.toggle.bind(this));
    this.addEventListener('blur', this.close.bind(this));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    const open = document.querySelectorAll('menu-drawer[data-state="open"]');
    open.forEach(i => {
      i.close();
    })
    this.menu.style.setProperty('left', 0);
    this.menu.style.removeProperty('right', 0);
    const rect = this.menu.getBoundingClientRect();
    if((window.innerWidth - rect.right) < 0) {
      this.menu.style.removeProperty('left');
      this.menu.style.setProperty('right', 0);
    }
    this.setAttribute('data-state', 'open');
    this.caret?.classList.add('rotate-180');
    this.isOpen = true;
    this.setFocus();
  }

  close(event = false) {
    if(event && this.contains(event.relatedTarget)) {
      return false;
    }
    this.setAttribute('data-state', 'closed');
    this.caret?.classList.remove('rotate-180');
    this.isOpen = false;
  }

  setFocus() {
    window.setTimeout(() => this.focus(), 100);
  }
}

customElements.define('menu-drawer', MenuDrawer);